<template>
  <div class="rich-editor">
    <Toolbar
      class="rich-editor-toolbar"
      :editor="editor"
      :default-config="toolbarConfig"
      :mode="mode"
    />
    <Editor
      class="rich-editor-body"
      style="height: 460px; overflow-y: hidden;"
      v-model="html"
      :default-config="editorConfig"
      :mode="mode"
      @onCreated="onCreated"
    />
  </div>
</template>

<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import '@wangeditor/editor/dist/css/style.css'
import http, { absoluteUrl, MAX_UPLOAD_FILE_SIZE, UPLOAD_TIMEOUT } from '../api'

export default {
  components: { Editor, Toolbar },
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入产品详情图文内容，可插入图片、表格、链接等'
    },
    bizType: {
      type: String,
      default: 'product-detail'
    }
  },
  data() {
    return {
      editor: null,
      html: this.value || '',
      mode: 'default',
      toolbarConfig: {},
      editorConfig: {
        placeholder: this.placeholder,
        scroll: true,
        MENU_CONF: {
          uploadImage: {
            maxFileSize: MAX_UPLOAD_FILE_SIZE,
            allowedFileTypes: ['image/*'],
            customUpload: this.uploadImage
          }
        }
      }
    }
  },
  watch: {
    value(value) {
      if (value !== this.html) {
        this.html = value || ''
      }
    },
    html(value) {
      this.$emit('input', value)
    }
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.destroy()
      this.editor = null
    }
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor)
    },
    async uploadImage(file, insertFn) {
      const form = new FormData()
      form.append('file', file)
      form.append('bizType', this.bizType)
      const data = await http.post('/admin/files/upload', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: UPLOAD_TIMEOUT
      })
      insertFn(absoluteUrl(data.url), file.name, data.url)
    }
  }
}
</script>
